import { CONTACTS } from "@/constants";
import { IconTypeEnum } from "@components/common/icon";

export const SUPPORT_DATA = {
  title: `Служба поддержки`,
  qa: { title: `Вопросы и ответы`, icon: IconTypeEnum.Faq, link: `/faq` },
  mail: CONTACTS.mail,
  // wa: CONTACTS.wa,
  tg: CONTACTS.tg,
};
